import * as types from 'modules/devices/actionTypes';
import { DeviceStatusEnum } from 'modules/devices/constants';
import type { Action } from 'modules/global/generic.types';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

export type DeviceFiltersState = {
  searchText: string | null;
  appVersion: string[];
  osVersion: string[];
  deviceTypes: string[];
  userId: string[];
  status: DeviceStatusEnum[];
};

const persistedFilters = getPersistedFilters()?.filters?.devices as Partial<DeviceFiltersState> | undefined;

const baseState: DeviceFiltersState = {
  searchText: null,
  appVersion: [],
  osVersion: [],
  deviceTypes: [],
  userId: [],
  status: [DeviceStatusEnum.ACTIVE, DeviceStatusEnum.INACTIVE],
};

const initialState: DeviceFiltersState = {
  ...baseState,
  ...(persistedFilters ?? {}),
};

const removeFilter = (
  state: DeviceFiltersState,
  { payload }: Action<{ filter: keyof DeviceFiltersState; value?: string }>
): DeviceFiltersState => {
  const { filter, value } = payload!;
  const newValue = value ? (state[filter] as string[]).filter(current => current !== value) : [];

  return {
    ...state,
    [filter]: newValue,
  } as DeviceFiltersState;
};

const setFilter = (
  state: DeviceFiltersState,
  { payload }: Action<{ field: keyof DeviceFiltersState; value: unknown }>
): DeviceFiltersState => ({
  ...state,
  [payload!.field]: payload!.value,
} as DeviceFiltersState);

const clearFilters = (state: DeviceFiltersState): DeviceFiltersState => {
  const { searchText: _searchText, ...newFilters } = baseState;
  return {
    ...state,
    ...newFilters,
  };
};

export default createReducer<DeviceFiltersState>(initialState, {
  [types.REMOVE_FILTER]: removeFilter,
  [types.SET_FILTER]: setFilter,
  [types.CLEAR_FILTER]: clearFilters,
});
